<template>
    <div class="winning_modal_box">
        <b-modal ref="modal" id="winning_modal" centered no-close-on-backdrop>
            <div class="text-center">
                <h4>得獎名單</h4>
                <div class="htmltext">
                    2018/12/05 <br>
                    經典防刮皮革LOGO包 > 廖丹瑩<br>
                    鉚釘皮革手提包 > 陳紅
                    <hr>
                    2018/12/06 <br>
                    Coach「Perry」系列腕錶 > Irene Lai，Wen Hsueh<br>
                    <hr>
                    2018/12/07 <br>
                    CK Calvin Klein 服裝手套組 > 黃舒妤<br>
                    <hr>
                    2018/12/08 <br>
                    台北北投老爺酒店住宿券 > 武家媚<br>
                    <hr>
                    2018/12/09 <br>
                    Sisley 抗皺活膚御緻眼唇霜 > 冷靖文<br>
                    <hr>
                    2018/12/10 <br>
                    Proenza Schouler PS1 經典包款 > 葉媛<br>
                    <hr>
                    2018/12/11 <br>
                    EVE LOM 全能淨潤卸妝凝霜 > 蔡偉婷、葉靜穎、黃臻臻<br>
                    <hr>
                    2018/12/12 <br>
                    AIGLE 保暖防水商品 > Hsiu-Hui Chan<br>
                    <hr>
                    2018/12/13 <br>
                    Swarovski施華洛世奇水晶桌飾品 > 李佳霙<br>
                    <hr>
                    2018/12/14 <br>
                    AllSaints黑色Lara騎士皮衣 > 姜琪薇<br>
                    <hr>
                    2018/12/15 <br>
                    Kenzo粉色刺繡毛衣 > 林淑辰<br>
                    <hr>
                    2018/12/16 <br>
                    Lovelinks 串珠手環 > 邱茲鈴、周欣穎、洪雅帆<br>
                    <hr>
                    2018/12/17 <br>
                    Hunter 雨靴 > 徐淑涵、王采淇、張郁萱 <br>
                    <hr>
                    2018/12/18 <br>
                    極緻保濕眼部瞬效呵護禮盒 > Amber Wei、黃菲比、陳品縈、Angela Yu、Sin Yi Lin、PeiChen Lin、黃雯婕、施班班、李涴渝、Angel Queen <br>
                    <hr>
                    2018/12/19 <br>
                    Oster義式膠囊兩用咖啡機 > Lynn Chang <br>
                    <hr>
                    2018/12/20 <br>
                    by terry > 邱歆貽、Marco Ma <br>
                    <hr>
                    2018/12/21 <br>
                    Michael Kors Whitney 黑色鍊包 > Cona Chang <br>
                    <hr>
                    2018/12/22 <br>
                    NARS特霧唇誘組 > Hsiaowei Chung、Rong Rong Huang 、張圓圓、Ting Yu Lee、劉君君、黃熙容 <br>
                    <hr>
                    2018/12/23 <br>
                    品木宣言聖誕禮盒 > lemur wang、Sandra Chiang、花亦柔 <br>
                    <hr>
                    2018/12/24 <br>
                    台北文華東方酒店雙人套餐餐券 > Richard Fan <br>
                    <hr>
                    2018/12/25 <br>
                    迪奧DIOR聖誕禮盒 > Amelia Yao <br>
                    <hr>
                </div>
            </div>
            <div slot="modal-footer">
                <b-btn size="md" @click="hideModal">
                    關閉
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "winning_modal",
        methods: {
            hideModal () {
                this.$refs.modal.hide()
            },
        }
    }
</script>
